// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1SPWM","inner":"Footer_inner__3UbTT"};